
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/room/[slug]",
      function () {
        return require("private-next-pages/room/[slug]/index.tsx");
      }
    ]);
  